import { AgColDefsI, AgGridI,} from "../../../../shared/components/ag-grid/ag-grid.model";
import { DocumentCellRendererComponent } from "src/app/components/crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { AgDropdownCorrectFieldComponent } from "src/app/shared/components/ag-dropdown-correct-field/ag-dropdown-correct-field.component";



const RowNumberColumn: AgColDefsI = {
  headerName: "Row No",
  field: "rowNumber",
  minWidth: 100,
  width:110,
  suppressMovable: true,
  editable : false,
 // cellClass: "padding-left-38px",
 cellStyle:{'padding-left':"35px",'color':'#646E76'},
 // flex:1,
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const CommonRowNumberColumn: AgColDefsI = {
  headerName: "Row No",
  field: "rowNumber",
  minWidth: 100,
  editable : false,
  width:110,
  suppressMovable: true,
 cellStyle:{'padding-left':"35px",'color':'#646E76'},
 cellRenderer: params => params.value ?params.value : "&#8212",
};



const ColumnNameColumn: AgColDefsI = {
  headerName: "Column Name",
  field: "errorField",
  minWidth: 250,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",
  'color':'var(--sitewide_primary_accent_color)',
},
  //cellClass: "padding-left-38px",
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};

const CompanyNameColumn: AgColDefsI = {
  headerName: "Company Name",
  field: "company",
  minWidth: 250,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",
  'color':'var(--sitewide_primary_accent_color)',
},
  //cellClass: "padding-left-38px",
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const PartNumberColumn: AgColDefsI = {
  headerName: "Part Number",
  field: "name",
  minWidth: 250,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",
  'color':'var(--sitewide_primary_accent_color)',
  cellRenderer: params => params.value ?params.value : "&#8212",
},
};

const ErrorFieldColumn: AgColDefsI = {
  headerName: "Error Field",
  field: "errorData",
  minWidth: 150,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};

const ErrorFieldCompanyColumn: AgColDefsI = {
  headerName: "Error Field",
  field: "errorField",
  minWidth: 150,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const CommonErrorFieldCompanyColumn: AgColDefsI = {
  headerName: "Error Field",
  field: "errorField",
  minWidth: 150,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};


const ErrorDataColumn: AgColDefsI = {
  headerName: "Error Data",
  field: "errorData",
  minWidth: 150,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const CommonErrorDataColumn: AgColDefsI = {
  headerName: "Error Data",
  field: "errorData",
  minWidth: 150,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};



const CorrectFieldColumn: AgColDefsI = {
  headerName: "Correct Field",
  field: "correctField",
  minWidth: 300,
  width:300,
  sortable: true,
  editable : false,
  suppressMovable: true,
  flex:1,
  //cellClass: "padding-left-38px",
   cellRenderer: AgDropdownCorrectFieldComponent,
};

const ErrorTabCorrectFieldColumn: AgColDefsI = {
  headerName: "Correct Field",
  field: "correctField",
  minWidth: 300,
  width:300,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  //cellClass: "padding-left-38px",
   cellRenderer: AgDropdownCorrectFieldComponent,
   cellRendererParams: {isErrorTab: true}
};
const CommonCorrectFieldColumn: AgColDefsI = {
  headerName: "Correct Field",
  field: "correctField",
  minWidth: 300,
  width:300,
  editable : false,
  suppressMovable: true,
  flex:1,
   cellRenderer: AgDropdownCorrectFieldComponent,
};


const ErrorMessageColumn: AgColDefsI = {
  headerName: "Error Message",
  field: "errorMessage",
  minWidth: 350,
  sortable: true,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  //  cellRenderer: DocumentCellRendererComponent
  cellRenderer: params => params.value ?params.value : "&#8212",
};
const CommonErrorMessageColumn: AgColDefsI = {
  headerName: "Error Message",
  field: "errorMessage",
  minWidth: 350,
  suppressMovable: true,
  flex:1,
  editable : false,
  cellStyle:{'padding-left':"22px",'color':'#646E76'},
  cellRenderer: params => params.value ?params.value : "&#8212",
};


const SuccessSvgColumn: AgColDefsI = {
  headerName: "",
  field: "status",
  minWidth: 100,
  width:100,
  suppressMovable: true,
  editable : false,
 // flex:1,
  cellStyle:{'padding-left':"22px"},
  cellRenderer: DocumentCellRendererComponent,
//   cellRenderer: function(params) {
//     return `<span> <img src='../../../../assets/SVGIcons/${params.value == true ? 'check-mark (1)' : 'Group 41672'}.svg'> </span>`
// }
  
};
const CommonSuccessSvgColumn: AgColDefsI = {
  headerName: "",
  field: "status",
  minWidth: 100,
  width:100,
  editable : false,
  suppressMovable: true,
  cellStyle:{'padding-left':"22px"},
  cellRenderer: DocumentCellRendererComponent,
};




export enum ErrorFiledName
{
  SALE_STAGE      = 'Sale Stage',
  STATE           = 'State',
  COUNTRY         = 'Country',
  SALESPERSON     = 'Salesperson',
  ALT_SALESPERSON = 'Alt Salesperson',
  BUYERS_REP      = 'Buyer’s Rep'
}

export const ColDefsDocumentsCode: AgColDefsI[] = [
  RowNumberColumn,
  ColumnNameColumn,
  ErrorFieldColumn,
  ErrorTabCorrectFieldColumn,
  ErrorMessageColumn,
  SuccessSvgColumn,
];

export const ColDefsDocuments: AgColDefsI[] = [
  RowNumberColumn,
  CompanyNameColumn,
  // ErrorFieldColumn,
  ErrorFieldCompanyColumn,
  ErrorDataColumn,
  CorrectFieldColumn,
  ErrorMessageColumn,
  SuccessSvgColumn,
];
export const ColDefsCommonError: AgColDefsI[] = [
  CommonRowNumberColumn,
  PartNumberColumn,
  CommonErrorFieldCompanyColumn,
  CommonErrorDataColumn,
  CommonCorrectFieldColumn,
  CommonErrorMessageColumn,
  CommonSuccessSvgColumn,
];



export const AgGridImportCompaniesErrors: AgGridI = {
  colDefs: ColDefsDocuments,
  rowSelection: "multiple",
};
export const AgGridImportCodecrosswalkErrors: AgGridI = {
  colDefs: ColDefsDocumentsCode,
  rowSelection: "multiple",
};
export const AgGridImportCommonErrors: AgGridI = {
  colDefs: ColDefsCommonError,
  rowSelection: "multiple",
};
export const AgGridImportBOMMapErrors: AgGridI = {
  colDefs: ColDefsDocuments,
  rowSelection: "multiple",
};
